import * as types from './productActionTypes';

export const getProductRequest = (payload) => 
({ type: types.GET_PRODUCT_REQUEST, payload });
export const getProductSuccess = (payload) => 
({ type: types.GET_PRODUCT_SUCCESS, payload });
export const getProductError = (payload) => 
({ type: types.GET_PRODUCT_ERROR, payload });

export const addProductRequest = (payload) => 
({ type: types.ADD_PRODUCT_REQUEST, payload });
export const addProductSuccess = (payload) => 
({ type: types.ADD_PRODUCT_SUCCESS, payload });
export const addProductError = (payload) => 
({ type: types.ADD_PRODUCT_ERROR, payload });

export const updateProductRequest = (payload) => 
({ type: types.UPDATE_PRODUCT_REQUEST, payload });
export const updateProductSuccess = (payload) => 
({ type: types.UPDATE_PRODUCT_SUCCESS, payload });
export const updateProductError = (payload) => 
({ type: types.UPDATE_PRODUCT_ERROR, payload });

export const deleteProductRequest = (payload) => 
({ type: types.DELETE_PRODUCT_REQUEST, payload });
export const deleteProductSuccess = (payload) => 
({ type: types.DELETE_PRODUCT_SUCCESS, payload });
export const deleteProductError = (payload) => 
({ type: types.DELETE_PRODUCT_ERROR, payload });

export const getProductDetailRequest = (payload) => 
({ type: types.GET_PRODUCT_DETAIL_REQUEST, payload });
export const getProductDetailSuccess = (payload) => 
({ type: types.GET_PRODUCT_DETAIL_SUCCESS, payload });
export const getProductDetailError = (payload) => 
({ type: types.GET_PRODUCT_DETAIL_ERROR, payload }); 